<template>
  <div v-show="visible">
    <!-- MAIN -->
    <div class="list-analytics analysis-chart">
      <div :class="['t-chart', { 'c-pointer': existSubCharts }]">
        <div v-if="existSubCharts" class="title corner" @click="onShowSubChartButtonClick">
          {{ mainChart.name }}
          <div :class="addButtonIconName"></div>
        </div>
        <div v-else class="title">{{ mainChart.name }}</div>
        <w-plot-area-chart
          v-if="mainChart.type === 'area'"
          ref="mainChart"
          :active="active"
          :visible="visible"
          :rscInfoList="getRscInfoListByRscKey(mainChart.rscInfoList, mainObj.rscKey)"
          :obj-info="mainObj"
          :showObjName="true"
          @clickChart="onClickChart"
        />
        <w-plot-line-chart v-else ref="mainChart" :active="active" :visible="visible" :rscInfoList="getRscInfoListByRscKey(mainChart.rscInfoList, mainObj.rscKey)" :obj-info="mainObj" :showObjName="true" @clickChart="onClickChart" />
      </div>
    </div>
    <!-- SUB -->
    <div v-if="existSubCharts && showSubCharts" class="sub-chart-wrapper">
      <div class="list-analytics analysis-chart" v-for="subObj in subObjList" :key="subObj.rscKey">
        <div class="t-chart">
          <div class="title">{{ mainChart.name }}</div>
          <w-plot-area-chart
            v-if="mainChart.type === 'area'"
            :ref="`${subObj.rscKey}Chart`"
            :active="active"
            :visible="showSubCharts"
            :rscInfoList="getRscInfoListByRscKey(mainChart.rscInfoList, subObj.rscKey)"
            :obj-info="subObj"
            :showObjName="true"
            @clickChart="onClickChart"
          />
          <w-plot-line-chart v-else :ref="`${subObj.rscKey}Chart`" :active="active" :visible="showSubCharts" :rscInfoList="getRscInfoListByRscKey(mainChart.rscInfoList, subObj.rscKey)" :obj-info="subObj" :showObjName="true" @clickChart="onClickChart" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isNil, isEmpty, clone, pullAt, forEach } from 'lodash';
import PerformanceAnalysisChartMixin from './mixins/performance-analysis-chart';

export default {
  name: 'WPerformanceAnalysisMultiRscKeyChart',
  mixins: [PerformanceAnalysisChartMixin],
  props: {
    objList: {
      type: Array,
    },
  },
  data() {
    return {
      mainObj: {},
      subObjList: [],
    };
  },
  watch: {
    chartData: {
      immediate: true,
      handler(value) {
        this.showSubCharts = false;
        if (!isEmpty(value)) {
          this.mainChart = value.mainChart;
          const objList = isNil(this.mainChart.filterObjFn) ? clone(this.objList) : this.mainChart.filterObjFn(this.objList);
          this.mainObj = objList[0];
          if (objList.length > 1) {
            this.existSubCharts = true;
            pullAt(objList, 0);
            this.subObjList = objList;
          } else {
            this.existSubCharts = false;
            this.subObjList = [];
          }
        } else {
          this.mainChart = {};
          this.subObjList = [];
          this.existSubCharts = false;
        }
      },
    },
  },
  methods: {
    getRscInfoListByRscKey(rscInfoList, rscKey) {
      const list = [];
      forEach(rscInfoList, (rscInfo) => {
        list.push({
          ...rscInfo,
          rscKey,
        });
      });
      return list;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/components/PerformanceAnalysisChartView/PerformanceAnalysisMultiRscKeyChart.vue